module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-available-blue-5ea221.svg";